export default "__VITE_ASSET__BlZm_lwM__"